import React from "react";
import styled from "styled-components";
import { Colors, theme } from "../../../theme";
import { convertToRgba } from "../../../utils";

const Button = styled.button`
  padding: 8px;
  margin: -8px;
  border-radius: 50%;
  cursor: pointer;
  background: none;
  border: none;

  :hover {
    background-color: ${theme(
      convertToRgba(Colors.gray[300], 0.13),
      convertToRgba(Colors.gray[100], 0.13)
    )};
  }

  :focus {
    outline: none;
  }

  :focus-visible,
  :active {
    background-color: ${theme(
      convertToRgba(Colors.gray[300], 0.25),
      convertToRgba(Colors.gray[100], 0.25)
    )};
  }
`;

type IconButtonProps = React.ComponentPropsWithoutRef<"button"> & {
  children: React.ReactElement;
  "aria-label": string;
};

export function IconButton(props: IconButtonProps) {
  const { "aria-label": ariaLabel, children, ...rest } = props;
  return (
    <Button aria-label={ariaLabel} {...rest}>
      {children}
    </Button>
  );
}

export default IconButton;
